import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import config from '../../../config';

export const Type_Of_Bot_Modal = () => {

    const [modal_standard, setmodal_standard] = useState(false);
    function tog_standard() {
        setmodal_standard(!modal_standard);
    }

  return (
    <>
         <span color="secondary" onClick={() => tog_standard()} style={{ backgroundColor: 'transparent', border: 'none', padding: '0px', fontSize: '18px', cursor: 'pointer'}}><i className="ri-question-line"></i></span>
      
       {/* Default Modal */}
       <Modal id="myModal"
                isOpen={modal_standard}
                toggle={() => {
                    tog_standard();
                }}
            >
                <ModalHeader className="modal-title"
                    id="myModalLabel" toggle={() => {
                        tog_standard();
                    }}>
                    Bot type
                </ModalHeader>
                <ModalBody>
                    {/* <h5 className="fs-15">
                    number or null
                    </h5> */}
                    <p className="text-muted">{config.tool_tip.bot_type}</p>
                    <p className=""><b>General Bot</b></p>
                    <p className="text-muted" style={{marginBottom:'0px'}}>{config.tool_tip.general_bot_one}</p>
                    <p className="text-muted">{config.tool_tip.general_bot_two}</p>
                    <p className=""><b>DB Bot</b></p>
                    <p className="text-muted" style={{marginBottom:'0px'}}>{config.tool_tip.db_bot_one}</p>
                    <p className="text-muted">{config.tool_tip.db_bot_two}</p>
                    
                    {/* <p className="text-muted"></p> */}
                </ModalBody>
                
            </Modal>
    </>
  )
}
